export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((reg) => {
          console.log('Service Worker kayıtlı:', reg.scope);
        })
        .catch((err) => {
          console.log('Service Worker kayıt hatası:', err);
        });
    });
  }
}
